import { render, staticRenderFns } from "./unitType.vue?vue&type=template&id=629b29bc&scoped=true"
import script from "./unitType.vue?vue&type=script&lang=js"
export * from "./unitType.vue?vue&type=script&lang=js"
import style0 from "./unitType.vue?vue&type=style&index=0&id=629b29bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629b29bc",
  null
  
)

export default component.exports